// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex } from '@iheartjane/reefer';

export const Container = styled(Flex)(({ theme }) => {
  return {
    borderColor: theme.colors.grays.light,
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
  };
});

export const TextArea = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.grays.white,
  borderRadius: 16,
}));

export const ImageArea = styled(Flex)<{ variant: 'brand' | 'store' }>(
  ({ variant, theme }) => ({
    backgroundColor:
      variant === 'store'
        ? theme.colors.brand.sunset.main
        : theme.colors.grays.ultralight,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  })
);
